/** Shared block spacing, stored as reserved scalars alongside block content. */
export const BLOCK_SPACING_PX = { "0": 0, M: 48, L: 96, XL: 144 };
export const BLOCK_MOBILE_SPACING_PX = {
    "0": 0,
    M: 40,
    L: 60,
    XL: 80,
};
export const DEFAULT_BLOCK_SPACING = "L";
export const BLOCK_PADDING_TOP_KEY = "paddingTop";
export const BLOCK_PADDING_BOTTOM_KEY = "paddingBottom";
export const BLOCK_SPACING_OPTIONS = Object.entries(BLOCK_SPACING_PX).map(([value, pixels]) => ({
    value,
    label: value === "0"
        ? "0 px"
        : `${value} — ${pixels} px (${BLOCK_MOBILE_SPACING_PX[value]} px mobile)`,
}));
/** Legacy or invalid values use the same default as a newly inserted block. */
export function resolveBlockSpacing(value) {
    return value === "0" || value === "M" || value === "L" || value === "XL"
        ? value
        : DEFAULT_BLOCK_SPACING;
}
//# sourceMappingURL=block-spacing.js.map